<!-- <p>password-change-dialog works!</p> -->
<div
  class=""
  [ngClass]="{
    'password-change-dialog-container':
      screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
    'password-change-dialog-container-mobile': screenSize == ScreenType.Mobile
  }"
>
  <div class="password-change-dialog-header">
    <b>Password Change</b>
    <button mat-mini-fab mat-dialog-close>
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <div class="same-password-prompt" *ngIf="isSamePassword">
    Please already exisits!
  </div>
  <div class="unique-password-prompt" *ngIf="isUniquePassword">
    Password Unique, Please update!
  </div>
  <form [formGroup]="createPwdFormGroup">
    <mat-grid-list
      [rowHeight]="
        screenSize == ScreenType.Mobile
          ? '80px'
          : isSamePassword || isUniquePassword
          ? '80px'
          : '90px'
      "
      cols="1"
    >
      <mat-grid-tile
        ><mat-form-field
          subscriptSizing="dynamic"
          appearance="outline"
          hideRequiredMarker
        >
          <mat-label>Create Password</mat-label>
          <input
            formControlName="password"
            matInput
            [type]="hide ? 'password' : 'text'"
          />
          <button
            mat-icon-button
            matSuffix
            (click)="hide = !hide"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide"
          >
            <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
          </button>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field
          subscriptSizing="dynamic"
          appearance="outline"
          hideRequiredMarker
        >
          <mat-label>Confirm Password</mat-label>
          <input
            formControlName="confirmPassword"
            matInput
            [type]="hideCnf ? 'password' : 'text'"
          />
          <button
            mat-icon-button
            matSuffix
            (click)="hideCnf = !hideCnf"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hideCnf"
          >
            <mat-icon>{{ hideCnf ? "visibility_off" : "visibility" }}</mat-icon>
          </button>
        </mat-form-field></mat-grid-tile
      >
      <mat-grid-tile [rowspan]="screenSize == ScreenType.Mobile ? 3 : 2">
        <div class="password-validation-labels">
          <label
            class=""
            [ngClass]="
              createPwdFormGroup.controls['password'].hasError('required') ||
              createPwdFormGroup.controls['password'].hasError('minlength')
                ? 'text-danger'
                : 'text-success'
            "
          >
            <i class="material-icons">{{
              createPwdFormGroup.controls["password"].hasError("required") ||
              createPwdFormGroup.controls["password"].hasError("minlength")
                ? "cancel"
                : "check_circle"
            }}</i>
            Must be at least 8 characters
          </label>
          <label
            class=""
            [ngClass]="
              createPwdFormGroup.controls['password'].hasError('required') ||
              createPwdFormGroup.controls['password'].hasError('hasNumber')
                ? 'text-danger'
                : 'text-success'
            "
          >
            <i class="material-icons">{{
              createPwdFormGroup.controls["password"].hasError("required") ||
              createPwdFormGroup.controls["password"].hasError("hasNumber")
                ? "cancel"
                : "check_circle"
            }}</i>
            Must contain at least 1 number
          </label>
          <label
            class=""
            [ngClass]="
              createPwdFormGroup.controls['password'].hasError('required') ||
              createPwdFormGroup.controls['password'].hasError('hasCapitalCase')
                ? 'text-danger'
                : 'text-success'
            "
          >
            <i class="material-icons">{{
              createPwdFormGroup.controls["password"].hasError("required") ||
              createPwdFormGroup.controls["password"].hasError("hasCapitalCase")
                ? "cancel"
                : "check_circle"
            }}</i>
            Must contain at least 1 in Capital Case
          </label>
          <label
            class=""
            [ngClass]="
              createPwdFormGroup.controls['password'].hasError('required') ||
              createPwdFormGroup.controls['password'].hasError('hasSmallCase')
                ? 'text-danger'
                : 'text-success'
            "
          >
            <i class="material-icons">{{
              createPwdFormGroup.controls["password"].hasError("required") ||
              createPwdFormGroup.controls["password"].hasError("hasSmallCase")
                ? "cancel"
                : "check_circle"
            }}</i>
            Must contain at least 1 Letter in Small Case
          </label>
          <label
            class=""
            [ngClass]="
              createPwdFormGroup.controls['password'].hasError('required') ||
              createPwdFormGroup.controls['password'].hasError(
                'hasSpecialCharacters'
              )
                ? 'text-danger'
                : 'text-success'
            "
          >
            <i class="material-icons">{{
              createPwdFormGroup.controls["password"].hasError("required") ||
              createPwdFormGroup.controls["password"].hasError(
                "hasSpecialCharacters"
              )
                ? "cancel"
                : "check_circle"
            }}</i>
            Must contain at least 1 Special Character
          </label>
          <label
            [ngClass]="
              createPwdFormGroup.controls['confirmPassword'].hasError(
                'required'
              ) ||
              createPwdFormGroup.controls['confirmPassword'].hasError(
                'NoPassswordMatch'
              )
                ? 'text-danger'
                : 'text-success'
            "
          >
            <i class="material-icons">{{
              createPwdFormGroup.controls["confirmPassword"].hasError(
                "required"
              ) ||
              createPwdFormGroup.controls["confirmPassword"].hasError(
                "NoPassswordMatch"
              )
                ? "cancel"
                : "check_circle"
            }}</i>
            {{
              createPwdFormGroup.controls["confirmPassword"].hasError(
                "required"
              )
                ? " Password is Required"
                : createPwdFormGroup.controls["confirmPassword"].hasError(
                    "NoPassswordMatch"
                  )
                ? " Password do not match"
                : "Password Matched"
            }}
          </label>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </form>
  <div class="password-change-dialog-action">
    <!-- <button mat-raised-button mat-dialog-close>Cancel</button> -->
    <!-- <button
      [disabled]="createPwdFormGroup.invalid || isPasswordVerified"
      mat-raised-button
      (click)="onVerifyPassword()"
    >
      {{
        isPasswordVerified ? "Verified" : isVerifying ? "Verifying" : "Verify"
      }}
      <mat-icon *ngIf="isVerifying"
        ><mat-spinner class="button-spinner" diameter="18"> </mat-spinner
      ></mat-icon>
    </button> -->
    <button
      [disabled]="createPwdFormGroup.invalid"
      [mat-dialog-close]="createPwdFormGroup.value"
      mat-raised-button
    >
      Update
    </button>
  </div>
</div>
